import { useEffect } from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { EntityData } from "@/services/api/types";

interface UseActivityModalLifecycleParams {
  isOpen: boolean;
  entityType: EntityType;
  entityData: EntityData | undefined;
  isEditMode: boolean;
  formRef: React.RefObject<HTMLFormElement>;
  formSetValue: any;
  resetModalState: () => void;
  resetParticipantNames: () => void;
  resetPeopleData: () => void;
  setSelectedParticipants: (participants: string[]) => void;
  additionalResetLogic?: () => void;
  additionalOpenLogic?: () => void;
}

export const useActivityModalLifecycle = ({
  isOpen,
  entityType,
  entityData,
  isEditMode,
  formRef,
  formSetValue,
  resetModalState,
  resetParticipantNames,
  resetPeopleData,
  setSelectedParticipants,
  additionalResetLogic,
  additionalOpenLogic
}: UseActivityModalLifecycleParams) => {
  useEffect(() => {
    if (!isOpen) {
      resetModalState();
      resetParticipantNames();
      resetPeopleData();
      setSelectedParticipants([]);
      formRef.current?.reset();
      if (additionalResetLogic) {
        additionalResetLogic();
      }
    } else {
      if (entityType === EntityType.PERSON && entityData?.id) {
        setSelectedParticipants([entityData.id]);
      }

      if (additionalOpenLogic) {
        additionalOpenLogic();
      }
    }
  }, [
    isOpen,
    entityType,
    entityData?.id,
    resetModalState,
    resetParticipantNames,
    resetPeopleData,
    setSelectedParticipants,
    formRef,
    additionalResetLogic,
    additionalOpenLogic
  ]);

  useEffect(() => {
    if (typeof formSetValue === "function" && isOpen && !isEditMode) {
      if (entityType === EntityType.PERSON && entityData?.id) {
        formSetValue("participants", [entityData.id], {
          shouldValidate: true
        });
      }
    }
  }, [formSetValue, isOpen, isEditMode, entityType, entityData?.id]);
};
